import * as actionConsts from './actions';
import update from 'react/lib/update';


export const initState = {
  activities: {},
  activityOrganizer: [],
  project: {},
  unread: [],
  isLoading: false,
  routine: 0,
  employees: [],
  draggingEmployee: null,
  isResetLoading: false,
  employeeSuggestions: [],
  employeesWithConflict: [],
  isSavingConflicted: false,
  isSavingRegistration: false,
  date: new Date(),
  activityIsDragging: false,
  registrationDate: new Date(),
  employeesIsFetching: false
}




export default function(state=initState, action) {
  switch (action.type) {
    case actionConsts.GET_ACTIVITIES_REQUEST:
      return update(state, {
        isLoading: {
          $set: true
        }
      });
    case actionConsts.GET_ACTIVITIES_SUCCESS:
      return update(state, {
        activities: {
          $set: action.activities
        },
        activityOrganizer: {
          $set: action.activityOrganizer
        },
        project: {
          $set: action.project
        },
        unread: {
          $set: action.unread
        },
        isLoading: {
          $set: false
        }
      });
    case actionConsts.GET_ACTIVITIES_FAILURE:
      return update(state, {
        isLoading: {
          $set: false
        }
      });
    case actionConsts.UPDATE_ACTIVITY_ORGANIZER:
      return update(state, {
        activityOrganizer: {
          $set: action.activityOrganizer
        }
      });
    case actionConsts.ADD_UNREAD_CHAT_MESSAGE:
      return update(state, {
        unread: {
          $push: [action.activityId]
        }
      });
    case actionConsts.UPDATE_ACTIVITY:
      return update(state, {
        activities: {
          [action.activityId]: {
            registered: {
              $set: action.registered
            },
            today: {
              $set: action.today
            },
            pool: {
              $set: action.pool
            }
          }
        }
      });
    case actionConsts.UPDATE_ACTIVITY_REGISTERED:
      return update(state, {
        activities: {
          [action.activityId]: {
            registered: {
              $set: action.registered
            }
          }
        }
      });
    case actionConsts.GET_EMPLOYEES_REQUEST:
      return update(state, {
        employeesIsFetching: {
          $set: true
        }
      });
    case actionConsts.GET_EMPLOYEES_SUCCESS:
      return update(state, {
        routine: {
          $set: action.routine
        },
        employees: {
          $set: action.employees
        },
        employeesIsFetching: {
          $set: false
        }
      });
    case actionConsts.REGISTER_HOURS:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            activities:{
              $push: [{id: action.activityId, hours: 0}]
            }
          }
        },
        activities: {
          [action.activityId]: {
            droppedEmployees: {
              [action.employeeId]: {
                $set: true
              }
            }
          }
        }
      });
    case actionConsts.SET_EMPLOYEE_IS_DRAGGING:
      return update(state, {
        draggingEmployee: {
          $set: action.employeeId
        }
      });
    case actionConsts.SET_EMPLOYEE_HOURS:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            hours:{
              $set: action.hours
            },
            absence:{
              $set: null
            }
          }
        }
      });
    case actionConsts.SET_EMPLOYEE_NIGHTHOURS:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            nightHours:{
              $set: action.hours
            },
            absence:{
              $set: null
            }
          }
        }
      })
    case actionConsts.RESET_EMPLOYEES_REQUEST:
      return update(state, {
        isResetLoading: {
          $set: true
        }
      });
    case actionConsts.RESET_EMPLOYEES_SUCCESS:
    case actionConsts.RESET_EMPLOYEES_FAILURE:
      return update(state, {
        isResetLoading: {
          $set: false
        }
      });
    case actionConsts.GET_EMPLOYEE_SUGGESTIONS_SUCCESS:
      return update(state, {
        employeeSuggestions: {
          $set: action.suggestions
        }
      });
    case actionConsts.ADD_EMPLOYEE_REQUEST:
      return update(state, {
        employees: {
          $splice: [[action.index, 0, action.employee]]
        }
      });
    case actionConsts.ADD_EMPLOYEE_FAILURE:
      return update(state, {
        employees: {
          $splice: [[0, 1]]
        }
      });
    case actionConsts.ADD_EMPLOYEES_WITH_CONFLICT:
      return update(state, {
        employeesWithConflict: {
          $set: action.employeesWithConflict
        }
      });
    case actionConsts.SET_DROPPED_EMPLOYEE:
      return update(state, {
        activities: {
          [action.activityId]: {
            droppedEmployees: {
              [action.employeeId]: {
                $set: true
              }
            }
          }
        }
      });
    case actionConsts.REMOVE_DROPPED_EMPLOYEE:
      return update(state, {
        activities: {
          [action.activityId]: {
            droppedEmployees: {
              [action.employeeId]: {
                $set: false
              }
            }
          }
        }
      });
    case actionConsts.SAVE_CONFLICTED_EMPLOYEE_REQUEST:
      return update(state, {
        isSavingConflicted: {
          $set: true
        }
      });
    case actionConsts.SAVE_CONFLICTED_EMPLOYEE_SUCCESS:
      return update(state, {
        isSavingConflicted: {
          $set: false
        },
        employeesWithConflict: {
          $set: []
        }
      });
    case actionConsts.SAVE_CONFLICTED_EMPLOYEE_FAILURE:
      return update(state, {
        isSavingConflicted: {
          $set: false
        }
      })
    case actionConsts.SET_EMPLOYEE_ABSENCE:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            absence:{
              $set: action.absence
            },
            activities: {
              $set: []
            },
            hours: {
              $set: 0
            },
            nightHours: {
              $set: 0
            }
          }
        }
      })
    case actionConsts.UPDATE_EMPLOYEE_ACTIVITIES:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            activities:{
              $set: action.activities
            },
            absence:{
              $set: action.absence
            }
          }
        }
      });
    case actionConsts.SET_ACTIVITY_IS_DRAGGING:
      return update(state, {
        activityIsDragging: {
          $set: action.isDragging
        }
      });
    case actionConsts.SET_DATE:
      return update(state, {
        date: {
          $set: action.date
        }
      });
    case actionConsts.SET_REGISTRATION_DATE:
      return update(state, {
        registrationDate: {
          $set: action.registrationDate
        }
      });
    case actionConsts.SAVE_REGISTRATION_REQUEST:
      return update(state, {
        isSavingRegistration: {
          $set: true
        }
      });
    case actionConsts.SAVE_REGISTRATION_SUCCESS:
      return update(state, {
        isSavingRegistration: {
          $set: false
        }
      });
    case actionConsts.SAVE_REGISTRATION_FAILURE:
      return update(state, {
        isSavingRegistration: {
          $set: false
        }
      });
    case actionConsts.UPDATE_EMPLOYEE:
      return update(state, {
        employees: {
          [action.employeeIndex]: {
            $set: action.employee
          }
        }
      });
      case actionConsts.REMOVE_EMPLOYEE_FROM_PROJECT:
        return update(state, {
          employees: {
            $splice: [[action.employeeIndex, 1]]
          }
        });
      case actionConsts.MOVE_EMPLOYEE_REQUEST:
      case actionConsts.MOVE_EMPLOYEE_FAILURE:
        return update(state, {
          employees: {
            $set: action.employees
          }
        });
      case 'UPDATE_TOTAL_REGISTERED':
        return update(state, {
          activities: {
            [action.rootActivityId]: {
              today: {
                $set: action.val
              }
            }
          }
        });
    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/reducer.js